export default {
	methods: {
		update_cnea_cod(t) {
			// Relacionamento cnae cipa
			let relCnaeCipa = this.assets.relacionamento_cnae_cipa.find(
				(item) => t.indexOf(item.cccp_cnae) != -1
			);
			(this.row.contrato.dados_tecnicos.cipa.grupo =
				relCnaeCipa.cccp_grupo),
				(this.row.contrato.dados_tecnicos.cipa.atividade_economica =
					relCnaeCipa.cccp_atividade_economica);

			// Grau de risco
			let before = 0;
			let gRisco = null;
			if (this.assets.grau_de_risco != undefined) {
				this.assets.grau_de_risco.forEach((item) => {
					if (
						t.indexOf(item.grr_cod) != -1 &&
						item.grr_cod.length > before
					) {
						before = item.grr_cod.length;
						gRisco = item;
					}
				});
				this.row.contrato.dados_tecnicos.grauRisco = parseInt(
					gRisco.grr_grau
				);
			}

			// Enquadramento Cipa ...
			let enq = this.assets.enquadramento_cipa.filter(
				(item) => item.grupo == relCnaeCipa.cccp_grupo
			);
			let tEnq = this.tipo_enquadramento();
			let efetivo = enq[0].membros ? 0 : 1;
			let suplente = efetivo == 0 ? 1 : 0;

			efetivo = enq[efetivo][tEnq] == '' ? 0 : enq[efetivo][tEnq];
			suplente = enq[suplente][tEnq] == '' ? 0 : enq[suplente][tEnq];

			this.row.contrato.dados_tecnicos.efetivo = efetivo;
			this.row.contrato.dados_tecnicos.suplente = suplente;
			this.row.contrato.dados_tecnicos.cipa.membros =
				parseInt(efetivo) + parseInt(suplente);
		},
		tipo_enquadramento() {
			let intervals = {
				i: [0, 19],
				ii: [20, 29],
				iii: [30, 50],
				iv: [51, 80],
				v: [81, 100],
				vi: [101, 120],
				vii: [121, 140],
				viii: [141, 300],
				ix: [301, 500],
				x: [501, 1e3],
				xi: [1e3, 2500],
				xii: [2501, 5e3],
				xiii: [5001, 1e4],
				xiv: [10001, 999999],
			};
			for (var type in intervals) {
				if (
					this.total_func >= intervals[type][0] &&
					this.total_func < intervals[type][1]
				) {
					return type;
				}
			}
		},
	},
};



// WEBPACK FOOTER //
// ./src/components/order-of-service/components/actions-components/js/cnae_update.mixin.js